<div class="row">
  <div class="col-md-9">
    <mat-form-field>
      <select
        matNativeControl
        [(ngModel)]="selected"
        (change)="onChangeProvider($event)"
      >
        <option
          *ngFor="let providersList of providers"
          [value]="providersList.value"
        >
          {{ providersList.text }}
        </option>
      </select>
    </mat-form-field>
  </div>
  <div class="col-md-3">
    <button
      (click)="openDialog('Add')"
      class="mt-4 pull-right"
      mat-raised-button
    >
      Create
    </button>
  </div>
</div>
<div class="table-responsive">
  <table mat-table [dataSource]="dataSource" matSort #mytable="matSort">
    <ng-container matColumnDef="action">
      <tr>
        <th mat-header-cell *matHeaderCellDef [ngClass]="'w-130'">Action</th>
      </tr>
      <tr>
        <td
          mat-cell
          *matCellDef="let element"
          [ngClass]="'w-130'"
          style="width: 5%"
        >
          <button
            mat-icon-button
            color="primary"
            title="Edit Contact"
            (click)="openDialog('Update', element)"
          >
            <mat-icon>edit</mat-icon>
          </button>
        </td>
      </tr>

      <tr></tr
    ></ng-container>
    <ng-container matColumnDef="ProviderName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header [ngClass]="'w-130'">
        Provider Name
      </th>
      <td mat-cell *matCellDef="let element" [ngClass]="'w-130'">
        {{ element.ProviderName }}
      </td>
    </ng-container>
    <!-- <ng-container matColumnDef="ProviderCloudLogo">
      <th mat-header-cell *matHeaderCellDef [ngClass]="'w-130'">
        ProviderCloudLogo
      </th>
      <td mat-cell *matCellDef="let element" [ngClass]="'w-130'">
        <img src="{{ element.ProviderCloudLogo }}" style="width: 65px" />
      </td>
    </ng-container> -->
    <ng-container matColumnDef="PromoCode">
      <th mat-header-cell *matHeaderCellDef [ngClass]="'w-130'">PromoCode</th>
      <td mat-cell *matCellDef="let element" [ngClass]="'w-130'">
        {{ element.PromoCode }}
      </td>
    </ng-container>

    <ng-container matColumnDef="ProviderEmail">
      <th mat-header-cell *matHeaderCellDef [ngClass]="'w-130'">
        ProviderEmail
      </th>
      <td mat-cell *matCellDef="let element" [ngClass]="'w-130'">
        {{ element.ProviderEmail }}
      </td>
    </ng-container>

    <ng-container matColumnDef="ProviderOperationHours">
      <th mat-header-cell *matHeaderCellDef [ngClass]="'w-130'">
        ProviderOperationHours
      </th>
      <td mat-cell *matCellDef="let element" [ngClass]="'w-130'">
        {{ element.ProviderOperationHours }}
      </td>
    </ng-container>
    <ng-container matColumnDef="ProviderPhone">
      <th mat-header-cell *matHeaderCellDef [ngClass]="'w-130'">
        ProviderPhone
      </th>
      <td mat-cell *matCellDef="let element" [ngClass]="'w-130'">
        {{ element.ProviderPhone }}
      </td>
    </ng-container>
    <ng-container matColumnDef="Provider_duns">
      <th mat-header-cell *matHeaderCellDef [ngClass]="'w-130'">
        Provider_duns
      </th>
      <td mat-cell *matCellDef="let element" [ngClass]="'w-130'">
        {{ element.Provider_duns }}
      </td>
    </ng-container>
    <ng-container matColumnDef="RecipientEmail">
      <th mat-header-cell *matHeaderCellDef [ngClass]="'w-130'">
        RecipientEmail
      </th>
      <td mat-cell *matCellDef="let element" [ngClass]="'w-130'">
        {{ element.RecipientEmail }}
      </td>
    </ng-container>
    <ng-container matColumnDef="Status">
      <th mat-header-cell *matHeaderCellDef [ngClass]="'w-130'">Status</th>
      <td mat-cell *matCellDef="let element" [ngClass]="'w-130'">
        {{ element.Status }}
      </td>
    </ng-container>
    <ng-container matColumnDef="UtilityContact">
      <th mat-header-cell *matHeaderCellDef [ngClass]="'w-130'">
        UtilityContact
      </th>
      <td mat-cell *matCellDef="let element" [ngClass]="'w-130'">
        {{ element.UtilityContact }}
      </td>
    </ng-container>
    <ng-container matColumnDef="UtilityName">
      <th mat-header-cell *matHeaderCellDef [ngClass]="'w-130'">UtilityName</th>
      <td mat-cell *matCellDef="let element" [ngClass]="'w-130'">
        {{ element.UtilityName }}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: displayedColumns"
      (click)="highlight(row._id, $event)"
    ></tr>
  </table>
</div>
<mat-paginator
  #providerPaginator="matPaginator"
  [pageSizeOptions]="[5, 10, 20]"
  showFirstLastButtons
>
</mat-paginator>
